import Ajax from '@/lib/ajax'

export default {
  // 获取分页
  getPageList(MaxResultCount: number, currentPage: number, KeyWord?: string, Published?: any) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
    }
    if(KeyWord) {
      params['Filter'] = KeyWord
    }
    if(Published != null) {
      params['Published'] = Published
    }
    return Ajax.get(`/api/MarketingManagement/RechargeableCouponCard/Paged`, {
      params
    })
  },
  // 根据id获取单行
  getDetail(id: string) {
    return Ajax.get(`/api/MarketingManagement/RechargeableCouponCard/${id}`)
  },
  // 根据id修改
  updateDetail(id: string, data: any) {
    return Ajax.put(`/api/MarketingManagement/RechargeableCouponCard/${id}`, data)
  },
  // 创建卡密
  createChargeCard(data: any) {
    return Ajax.post(`/api/MarketingManagement/RechargeableCouponCard`, data)
  },
  // 批量删除卡密子表
  batchDelete(ids: any) {
    let text = ids.join('&ids=')
    return Ajax.delete(`/api/MarketingManagement/RechargeableCouponCard?ids=${text}`)
  },

  // 创建卡密商品
  createChargeProductCard(data: any) {
    return Ajax.post(`/api/MarketingManagement/RechargeableCouponCard`, data)
  },
  // 根据id修改卡密商品
  updateProductDetail(id: string, data: any) {
    return Ajax.put(`/api/MarketingManagement/RechargeableCouponCard/${id}`, data)
  },
  // 根据id获取单行卡密商品
  getProductDetail(id: string) {
    return Ajax.get(`/api/MarketingManagement/RechargeableCouponCard/${id}`)
  },
  // 批量删除卡密子表
  batchDeleteProdcut(ids: any) {
    let text = ids.join('&ids=')
    return Ajax.delete(`/api/MarketingManagement/RechargeableCouponCard/Items?ids=${text}`)
  },
  // 自动生成随机卡密
  autoGenerate(number: number) {
    return Ajax.get(`/api/MarketingManagement/RechargeableCouponCard/Generate/${number}`)
  },
  // 导出卡密商品里面的卡密
  exportRechargeableProduct(id: string) {
    let params = {
      id
    }
    return Ajax.get(`/api/MarketingManagement/userCoupon/ExportItems`, {
      params,
      responseType: 'blob'
    })
  },
  // 导出卡密里面的卡密
  exportRechargeable(id: string) {
    return Ajax.get(`/api/MarketingManagement/RechargeableCard/export/${id}`, {
      responseType: 'blob'
    })
  },
   // 导出卡密换券里面的卡密
   exportRechargeableCoupon(id: string) {
    let params = {
      id
    }
    return Ajax.get(`/api/MarketingManagement/RechargeableCouponCard/ExportItems`, {
      params,
      responseType: 'blob'
    })
  },
}